/* eslint-disable react/jsx-props-no-spreading */
import { forwardRef } from 'react'
import PropTypes from 'prop-types'

import { BaseInput, InputLabel, InputWrapper, LabelSpacing, ErrorMessage, IconContainer, KilliIcon } from './styles'

const TextInput = forwardRef(
  ({ label = null, value = '', errorMessage = '', iconName = null, className = '', ...props }, ref) => {
    const hasIcon = !!iconName

    return (
      <InputWrapper className={className}>
        {label && <LabelSpacing />}
        {iconName && (
          <IconContainer>
            <KilliIcon className={`killi-icon-${iconName}`} />
          </IconContainer>
        )}
        <BaseInput value={value} {...props} ref={ref} className={hasIcon ? 'has-icon' : ''} />
        {label && (
          <InputLabel hasValue={!!value} className={hasIcon ? 'has-icon' : ''}>
            {label}
          </InputLabel>
        )}
        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      </InputWrapper>
    )
  },
)

TextInput.propTypes = {
  ...BaseInput.propTypes,
  label: PropTypes.string,
  value: PropTypes.string,
  errorMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.node])),
  ]),
  iconName: PropTypes.string,
  className: PropTypes.string,
}

export default TextInput
